import styled, { css } from 'styled-components';
import { StyledBox } from '../Box/Box.styles';
import { Flex } from '../Flex/Flex';
export var StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "StyledFlex",
  componentId: "core-12_20_1__sc-1quvv61-0"
})(["> ", "{", "}"], StyledBox, function (_ref) {
  var $direction = _ref.$direction;
  if ($direction !== null && $direction !== void 0 && $direction.includes('reverse')) {
    return css(["&:first-child{margin-bottom:0;margin-right:0;}&:last-child{margin-left:0;margin-top:0;}"]);
  }
  return css(["&:first-child{margin-left:0;margin-top:0;}&:last-child{margin-bottom:0;margin-right:0;}"]);
});
//# sourceMappingURL=FlexList.styles.js.map